interface StructuredAddress {
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  pincode?: string;
}

// Single source of address formatting, so any entity with this
// addressLine1/addressLine2/city/state/pincode shape (Tenant, Supplier,
// Customer, ...) renders identically wherever it's shown — Settings,
// supplier/customer details, sale/purchase invoice headers, etc.
export const formatAddress = (entity?: StructuredAddress | null): string => {
  if (!entity) return "";

  const lines = [
    entity.addressLine1,
    entity.addressLine2,
    entity.city,
    entity.state,
  ].filter(Boolean);
  let structured = lines.join(", ");
  if (entity.pincode) {
    structured += structured ? ` - ${entity.pincode}` : entity.pincode;
  }

  return structured;
};
